/** Tiny DOM helpers shared by the view layer. No game logic lives here. */

/** Builds a single element from an HTML string (the string is trusted/static). */
export function el<T extends HTMLElement = HTMLElement>(html: string): T {
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  const node = tpl.content.firstElementChild;
  if (!node) throw new Error('el(): template produced no element');
  return node as T;
}

/** querySelector that throws if the element is missing — surfaces wiring bugs early. */
export function qs<T extends Element = HTMLElement>(root: ParentNode, selector: string): T {
  const found = root.querySelector<T>(selector);
  if (!found) throw new Error(`Missing required element: ${selector}`);
  return found;
}

/** querySelectorAll as a typed array. */
export function qsa<T extends Element = HTMLElement>(root: ParentNode, selector: string): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}
